import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'
import { rem } from '@mantine/core'

export const StyledHomeFeatureBoxArticle = styled.div`
  padding: ${rem(16)};
  height: 100%;

  .cardArticleTitle {
    font-size: ${rem(16)} !important;
  }

  .cardArticleAuthorLabel {
    font-size: ${rem(12)} !important;
  }
`

export const StyledHomeFeatureBoxBody = styled.div`
  ${StyledHomeFeatureBoxArticle} {
    + ${StyledHomeFeatureBoxArticle} {
      border-top: 1px solid ${theme.colors.neutral100};
    }
  }
`

export const StyledHomeFeatureBoxTitle = styled.h3`
  color: ${theme.colors.gray800};
  font-size: ${rem(18)};
  font-weight: 600;
  line-height: ${rem(28)};
  letter-spacing: -0.4px;
  flex: 1;
  min-width: 0;
`

export const StyledHomeFeatureBoxTitleLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${rem(8)};
`

export const StyledHomeFeatureBoxHeader = styled.div`
  padding: ${rem(16)};
  border-bottom: 1px solid ${theme.colors.neutral100};
`

export const StyledHomeFeatureBox = styled.div`
  background-color: ${theme.colors.neutral50};
  border-radius: ${rem(24)};
  height: 100%;
`

export const StyledHomeFeature = styled.div``
